export default "__VITE_ASSET__MpsyDPAk__"